import { FC } from 'react'
import { AntTag } from '@agro-club/agroclub-shared'
import { Bid } from 'modules/domain/bid/types'
import { SampleStatus } from 'views/pages/Samples/types'
import useFormatDate from 'hooks/useFormatDate'
import { useTranslation } from 'react-i18next'
import { IconSample, IconCheckMark } from 'views/pages/Deal/Board/styled'

export const BidSampleTag: FC<{ bid: Bid }> = ({ bid }) => {
  const formatDate = useFormatDate()
  const { t } = useTranslation('samples')
  if (!bid.sample) return null
  let sampleRequestTag: string
  let Icon = IconSample
  if (bid.sample.status == SampleStatus.published) {
    sampleRequestTag = `${t('sample')}: ${formatDate(bid.sample.published_at)}`
    Icon = IconCheckMark
  } else {
    sampleRequestTag = t(`sampleRequestStatuses.${bid.sample.sample_request_status}`)
  }

  return (
    <AntTag icon={<Icon />} color="blue">
      {sampleRequestTag}
    </AntTag>
  )
}
